/*
 * 订单数据--故障率TOP20设备终端排行榜--高故障率终端
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import ScGridTable from "@/components/display/table/gridTableCore";
import { queryOrderCountDetail } from "@/fetch/fetchApi";

class FaultRateStub extends Component {
  state = {
    tableConfig: null,
  };

  componentWillMount() {
    // console.log("FaultRateStub componentWillMount", this.props);
    const modalParam = this.context.store.getState().modalInfo.param;
    this.setState({
      tableConfig: {
        tableKey: "faultRateStubTable",
        tableColumns: [
          {
            name: "设备编号",
            key: "stubId",
            colType: "textCol",
            align: "center",
          },
          {
            name: "订单编号",
            key: "orderId",
            colType: "textCol",
            align: "center",
          },
          {
            name: "故障原因",
            key: "endInfo",
            colType: "textCol",
            align: "center",
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
          ...modalParam,
        },
        dataApi: queryOrderCountDetail,
        autoRefresh: true, // 设置为true 直接加载grid数据
      },
    });
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  render() {
    return <ScGridTable config={this.state.tableConfig} />;
  }
}

export default FaultRateStub;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/detail/faultRateStub.js